export default "/images/bank-account.svg?bf75020d8ad043a9918076812f01685e";